import { Link, useParams } from 'react-router-dom';
import { StaticPageLayout } from '../../components/shopper/StaticPageLayout';
import { Card, CardContent } from '../../components/ui/card';
import { getBlogPost } from '../../content/site-pages';
import { ROUTES } from '../../constants/routes';

export function BlogPostPage() {
  const { slug } = useParams<{ slug: string }>();
  const post = slug ? getBlogPost(slug) : undefined;

  if (!post) {
    return (
      <StaticPageLayout title="Post not found">
        <Card>
          <CardContent className="p-8 text-center space-y-4">
            <p className="text-body">This blog post doesn&apos;t exist or may have been removed.</p>
            <Link to={ROUTES.blog} className="text-sm font-medium text-primary hover:underline">
              Back to the blog
            </Link>
          </CardContent>
        </Card>
      </StaticPageLayout>
    );
  }

  return (
    <StaticPageLayout title={post.title}>
      <p className="text-sm text-body">
        {new Date(post.date).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })}
      </p>

      <Card>
        <CardContent className="p-6 space-y-4">
          {post.body.map((paragraph) => (
            <p key={paragraph.slice(0, 40)} className="text-sm text-body leading-relaxed">
              {paragraph}
            </p>
          ))}
        </CardContent>
      </Card>

      <p className="text-sm text-body text-center">
        <Link to={ROUTES.blog} className="text-primary hover:underline">
          ← All posts
        </Link>
      </p>
    </StaticPageLayout>
  );
}
